import { TrackingService } from "../../../../shared/analytics/tracking.service";
import { PublicationTemplateType } from "../../publication-template/data/entities/publication-templates.entity";

export class BetaCampaignTrackingEvents {
  constructor(
    private readonly brandId: number,
    private readonly tracking: TrackingService,
    private readonly campaignId?: number,
  ) {}

  private capture(
    event: string,
    publicationType?: PublicationTemplateType,
  ): void {
    this.tracking.capture([event], {
      brand_id: this.brandId,
      campaign_id: this.campaignId,
      event_value: publicationType,
    });
  }

  public betaCampaignCreated(): void {
    this.capture("beta_campaign_created");
  }

  public publicationTemplateCreated(): void {
    this.capture("pt_create_btn_clicked");
  }

  public publicationTemplateTypeSelected(type: PublicationTemplateType): void {
    this.capture("pt_type_selected", type);
  }

  public mediaUploadStarted(type: PublicationTemplateType): void {
    this.capture("pt_media_upl_started", type);
  }

  public mediaUploadFailed(type: PublicationTemplateType): void {
    this.capture("pt_media_upl_failed", type);
  }

  public mediaUploadSucceeded(type: PublicationTemplateType): void {
    this.capture("pt_media_upl_success", type);
  }

  public publicationSaved(type: PublicationTemplateType): void {
    this.capture("pt_saved", type);
  }

  public publicationSchedulingStarted(type: PublicationTemplateType): void {
    this.capture("pt_schedule_start", type);
  }

  public publicationScheduled(type: PublicationTemplateType): void {
    this.capture("pt_schedule_created", type);
  }
}
